import React from 'react'
import { SUPPORT_EMAIL } from 'consts'

const HelpEmail = ({ style }) => (
  <a style={style} target="_blank" href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>
)

export default HelpEmail



// WEBPACK FOOTER //
// ./app/components/HelpEmail.js